import React from 'react';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { nb } from 'date-fns/locale';

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    return format(parseISO(dateStr), "d. MMMM yyyy, 'kl.' HH:mm", { locale: nb });
  } catch { return dateStr; }
};

const CommentHistoryCard = ({ comment, index }) => {
  const rotations = ['-1.2deg', '0.8deg', '-0.5deg', '1.5deg', '-1deg'];
  const rotate = rotations?.[index % rotations?.length];
  const accentColors = ['#3B6FD4', '#E76F51', '#2EC4A0', '#E9C46A', '#6B5CE7'];
  const accent = accentColors?.[index % accentColors?.length];

  return (
    <div
      style={{
        background: 'rgba(255,255,255,0.03)',
        border: `1px solid ${accent}33`,
        padding: '0',
        transform: `rotate(${rotate})`,
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        cursor: 'default',
        position: 'relative',
        overflow: 'hidden',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'rotate(0deg) scale(1.01)'; e.currentTarget.style.boxShadow = `0 8px 32px ${accent}22`; }}
      onMouseLeave={e => { e.currentTarget.style.transform = `rotate(${rotate})`; e.currentTarget.style.boxShadow = 'none'; }}
    >
      {/* Top color bar */}
      <div style={{ height: '4px', background: `linear-gradient(90deg, ${accent}, ${accent}44)` }} />
      <div style={{ padding: '20px' }}>
        {/* Article title */}
        <div style={{ marginBottom: '12px' }}>
          <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.55rem', color: accent, letterSpacing: '0.15em', textTransform: 'uppercase', display: 'block', marginBottom: '4px' }}>ARTIKKEL</span>
          <Link
            to={`/individual-article-detail-view?id=${comment?.post_id}`}
            style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '0.85rem', color: '#EEF0F2', textDecoration: 'none', lineHeight: 1.3, display: 'block' }}
            onMouseEnter={e => e.currentTarget.style.color = accent}
            onMouseLeave={e => e.currentTarget.style.color = '#EEF0F2'}
          >
            {comment?.blog_posts?.title || 'Ukjent artikkel'}
          </Link>
        </div>

        {/* Comment excerpt */}
        <blockquote style={{
          fontFamily: 'Georgia, serif',
          fontSize: '0.8rem',
          color: 'rgba(238,240,242,0.75)',
          fontStyle: 'italic',
          lineHeight: 1.6,
          borderLeft: `2px solid ${accent}66`,
          paddingLeft: '12px',
          margin: '0 0 16px 0',
        }}>
          {comment?.content?.length > 140 ? `${comment?.content?.slice(0, 140)}…` : comment?.content}
        </blockquote>

        {/* Footer row */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
          <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6rem', color: 'rgba(238,240,242,0.35)' }}>
            {formatDate(comment?.created_at)}
          </span>

          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {/* Status badge */}
            <span style={{
              fontFamily: 'JetBrains Mono, monospace', fontSize: '0.5rem',
              color: comment?.status === 'approved' ? '#2EC4A0' : comment?.status === 'pending' ? '#E9C46A' : '#E76F51',
              border: `1px solid ${comment?.status === 'approved' ? '#2EC4A0' : comment?.status === 'pending' ? '#E9C46A' : '#E76F51'}44`,
              padding: '2px 6px', letterSpacing: '0.1em', textTransform: 'uppercase',
            }}>
              {comment?.status === 'approved' ? 'GODKJENT' : comment?.status === 'pending' ? 'VENTER' : comment?.status?.toUpperCase()}
            </span>

            {/* Likes */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', background: `${accent}18`, padding: '4px 10px', border: `1px solid ${accent}33` }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill={accent} xmlns="http://www.w3.org/2000/svg">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
              <span style={{ fontFamily: 'Impact, sans-serif', fontSize: '0.85rem', color: accent }}>{comment?.likes_count || 0}</span>
            </div>

            {/* Replies */}
            {comment?.reply_count > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', background: 'rgba(255,255,255,0.04)', padding: '4px 10px', border: '1px solid rgba(255,255,255,0.08)' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(238,240,242,0.5)" strokeWidth="2" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
                <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6rem', color: 'rgba(238,240,242,0.5)' }}>{comment?.reply_count}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentHistoryCard;
